

/// <reference path="RenderTemplate.ts" />

// Generated class MessageTemplate_ManagedObject

class MessageTemplate_ManagedObject extends RenderTemplate
{
}
